export interface PatchInteractionRequest {
  updatedAt: Date;
}

export interface PatchInteractionResponse {
  success: boolean;
}

export interface InteractionUserResponses {
  questionId: number;
  text: string;
  submitted?: boolean;
  answers: {
    id?: number;
    text?: string;
    response?: string;
  }[];
}

export interface GetInteractionUserResponses {
  questionId: number;
  text: string;
  type: string;
  title: string;
  submitted?: boolean;
  answers:
    | {
      id?: number;
      index?: number;
      text: string;
      response?: string;
      negative?: boolean;
      unlocksQuestionUuids?: string[] | null;
      issueAlertIds?: string[] | null;
      issuePanelIds?: string[] | null;
      roundingFlagIds?: string[] | null;
      roundingFlagForRemovalIds?: string[] | null;
    }[]
    | [];
}

export enum InteractionEditStatusEnum {
  open = 'open',
  closed = 'closed',
}

export enum InteractionStatusEnum {
  completed = 'completed',
  incomplete = 'incomplete',
}

export interface UpdateUserResponsesInteractionType {
  editStatus: InteractionEditStatusEnum;
  responses: InteractionUserResponses[];
}

export interface UpdateInteractionPatchType
  extends UpdateUserResponsesInteractionType {
  id?: number;
  questionViewLog: ViewLogQuestion[];
  expired: boolean;
}

export interface UpdateInteractionResponseType {
  success: boolean;
}

export interface GetInteractionResponseDataType {
  id: number;
  coreInteractionId: string;
  scriptId: number;
  patientId?: string;
  encounterId?: string;
  unitId?: string;
  updatedAt: Date;
  createdAt: Date;
  editStatus: InteractionEditStatusEnum;
  questionViewLog: ViewLogQuestion[];
  responses: GetInteractionUserResponses[];
  status: InteractionStatusEnum;
  expired: boolean;
  percentScriptCompleted: number;
  percentScriptCompletedWithoutFreeText: number;
}

export interface CreateInteractionResponseType {
  id: number;
}

export interface CreateInteractionPostType {
  scriptId: number;
  patientId: string;
  encounterId: string;
  unitId: string;
}

export interface CreateStaffInteractionPostType {
  scriptId: number;
  staffMemberId: string;
}

export enum ViewLogActionEnum {
  new = 'new',
  edit = 'edit',
}
export interface ViewLogQuestion {
  action: ViewLogActionEnum;
  questionId: number;
  title?: string;
  text: string;
  timestamp: Date;
}
